import { Controller, useForm } from "react-hook-form";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import Button from "shared/UI/Buttons/Button";
import sanitize from "sanitize-html";
import { t } from "i18next";
import { Textarea } from "shared/UI/Textarea/Textarea";
import { useContactSupportFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

export const ContactSupport = () => {
  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: { dirtyFields },
  } = useForm({
    defaultValues: {
      message: "",
    },
  });
  const { modalNotify } = useNotifyModalContext();
  const { trigger: contactSupportAPI } = useContactSupportFunctionRequest();

  async function onSubmit() {
    const { message } = getValues();
    try {
      await contactSupportAPI({ body: { message: sanitize(message, { allowedTags: [], allowedAttributes: {} }) } });
      modalNotify("success", t("contactSupport.successMessage"));
      reset();
    } catch {
      modalNotify("error", t("contactSupport.errorTitle"), t("contactSupport.errorMessage"), t("contactSupport.errorCta"));
    }
  }

  return (
    <>
      <PageTitle title={t("pageTitle.account.contactSupport")} />
      <PageHeader narrowView title={t("contactSupport.title")} hideForMobile hideBackForDesktop />
      <NarrowContainer>
        <p className="pb-4">{t("contactSupport.description")}</p>

        <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name={"message"}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div className="text-font-dark">
                <Textarea id="message" maxLength={1000} rows={5} label={t("contactSupport.supportMessageInput")} onChange={onChange} value={value} />
              </div>
            )}
          />

          <Button
            type="submit"
            disabled={!dirtyFields.message}
            text={t("contactSupport.submitButton")}
            aria-label={t("contactSupport.submitButton")}
          />
        </form>
      </NarrowContainer>
    </>
  );
};
